"use strict";

// References
var alt = require("../alt");

class InventoryActions {
    // Data
    constructor() {
        this.generateActions(
            "clearItems",
            "getItems",
            "addItem",
            "importItems",
            "editItem",
            "deleteItem",
            "filterEquipment",
            "refreshFilter",
            "clearFilter",
            "commentOnItem"
        );
    }
}

module.exports = alt.createActions(InventoryActions);



// WEBPACK FOOTER //
// ./app/scripts/actions/InventoryActions.js